import React from 'react'
import { View, TouchableOpacity, Linking, Dimensions } from 'react-native'
import VimeoPlayer from './VimeoPlayer'
import ImageObject from '../Image/ImageObject'

const ClubKitchenFooter = () => {
	const handleMapPress = () => {
		Linking.openURL(
			'https://www.google.com/maps?ll=49.274945,-123.115545&z=16&t=m&hl=en-US&gl=US&mapclient=embed&q=988+Expo+Blvd+Vancouver,+BC+V6Z+0G2'
		)
	}

	return (
		<View
			style={{
				width: '100%',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				marginTop: -50,
			}}
		>
			<VimeoPlayer />
			<TouchableOpacity
				onPress={handleMapPress}
				style={{
					width: '100%',
				}}
			>
				<ImageObject
					source={require('../../assets/images/clubKitchenMap.png')}
					style={{
						width: '100%',
						marginBottom: Dimensions.get('window').width * 0.025,
						marginTop: Dimensions.get('window').width * -0.05,
					}}
				/>
			</TouchableOpacity>
		</View>
	)
}

export default ClubKitchenFooter
